module.exports = __webpack_public_path__ + "img/动态贴纸--大图gif.2ed8c318.gif";